/**
 * Deterministic avatar tint: hash the seed (initials or name) into one of
 * four Hearth palettes so a person keeps the same color everywhere.
 */
const palettes = [
  { bg: 'bg-primary-50', fg: 'text-primary-600' },
  { bg: 'bg-accent-50', fg: 'text-accent-600' },
  { bg: 'bg-warning-50', fg: 'text-warning-600' },
  { bg: 'bg-info-50', fg: 'text-info-600' },
] as const

export function avatarTint(seed: string): (typeof palettes)[number] {
  let hash = 0
  for (const char of seed) {
    hash = (hash * 31 + char.charCodeAt(0)) | 0
  }
  return palettes[Math.abs(hash) % palettes.length]
}

export function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('')
}
